import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

export const AmountsLabel: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')({
  padding: '2px 6px',
  border: '1px solid #DFE1E6',
  borderRadius: '3px',
  color: '#6B778C',
  fontWeight: 400,
  fontSize: '12px',
  background: '#FFFFFF',
  height: 'fit-content',
  '&>b': {
    fontWeight: 500,
    color: '#0065FF'
  }
});